import axios from 'axios';

// إنشاء نسخة مخصصة من axios
const api = axios.create({
  baseURL: '/api',
});

// 1. Interceptor للطلبات (إضافة التوكن تلقائياً)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 2. Interceptor للردود (قناص الـ 401)
api.interceptors.response.use(
  (response) => response, // لو الرد سليم، مرره عادي
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("🚫 Unauthorized! Redirecting to login...");
      
      // مسح البيانات المنتهية
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // توجيه لصفحة اللوجن (باستخدام window.location لضمان إعادة تحميل الأبليكيشن)
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;